module.exports = __webpack_public_path__ + "img/icon_krw.ee3a98a4.svg";